export default "https://client.chat.ao.com/1289/beta/without-externals/assets/images/fatal-error.jpg?f009a1fce439f8f969a0dfa228662924";